module.exports = __webpack_public_path__ + "media/country_flags/gf-15a084a0.png";